<template>
	<div id="app">
		<Header :show_back="show_back" :show_login="show_login" />
		<Navbar v-if="show_nav" />
		<transition name="fade" mode="out-in">
			<router-view v-on:showFooter="showFooter" v-on:showNav="showNav" v-on:showLogin="showLogin"
				v-on:showBack="showBack" class="router" ref="router"></router-view>
		</transition>
		<Footer v-if="show_footer" />
		<SideService></SideService>
	</div>
</template>
<script>
	import Header from "@/components/Header.vue";
	import Footer from "@/components/Footer.vue";
	import Navbar from "@/components/Navbar.vue";
	import SideService from "@/components/Service.vue";
	import {getOssToken, getSetting} from "@/api/index.js"
	export default {
		components: {
			Header,
			Navbar,
			Footer,
			SideService
		},
		data() {
			return {
				show_back: false,
				show_login: true,
				show_nav: true,
				show_footer: true,
			};
		},
		methods: {
			showLogin(bool) {
				this.show_login = bool;
			},
			showBack(bool) {
				this.show_back = bool;
			},
			showNav(bool) {
				this.show_nav = bool;
			},
			showFooter(bool) {
				this.show_footer = bool;
			},
			async getOssToken() {
				let json = await getOssToken()
				this.$store.commit('setAliYunOSS',json.data)
			},
			async initSetting() {
				getSetting({}).then(response => {
					let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
					link.type = 'image/x-icon';
					link.rel = 'shortcut icon';
					link.href = response.data.favicon;
					document.getElementsByTagName('head')[0].appendChild(link);
					document.title = response.data.document_title
					this.$store.commit("updateSetting", response.data)
				})
			}
		},
		created() {
			this.getOssToken()
			this.initSetting()
		}
	};
</script>
<style>
	#app {
		font-family: PingFang SC;
	}
</style>
